export default "__VITE_ASSET__978b6e04__"